import { collections, heroImage, siteStats } from "@/mocks/home";

export default function HeroSection() {
  const featured = collections[0];

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="黑料bu 主题合集整理的抽象暖色背景"
          title="黑料bu 黑料合集整理入口背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-950/85 via-secondary-950/75 to-secondary-950/90"></div>
      </div>

      <div className="relative mx-auto w-full px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
          <div className="anim-fade-up lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-3.5 py-1.5 font-label text-xs font-medium text-accent-300">
              <i className="ri-layout-masonry-line w-4 h-4 flex items-center justify-center"></i>
              主题合集 · 集中查阅入口
            </span>

            <p className="mt-6 font-heading text-3xl font-bold leading-[1.2] text-background-50 md:text-5xl">
              黑料bu ——
              <br />
              把黑料合集整理成
              <span className="text-accent-400">可查阅的入口</span>
            </p>

            <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-100/80 md:text-base">
              <strong className="font-semibold text-background-50">黑料bu</strong> 把分散的
              <strong className="font-semibold text-background-50">黑料合集</strong>按主题分类整理，打包呈现关键材料与背景脉络。需要
              <strong className="font-semibold text-background-50">黑料汇总</strong>或
              <strong className="font-semibold text-background-50">黑料大全</strong>时，这里就是一个省时省力的集中查阅入口。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#collections"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-layout-grid-line w-4 h-4 flex items-center justify-center"></i>
                进入合集索引
              </a>
              <a
                href="#archive"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/25 bg-background-50/5 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-download-2-line w-4 h-4 flex items-center justify-center"></i>
                下载整理包
              </a>
            </div>

            <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-background-100/15 pt-8 sm:grid-cols-4">
              {siteStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-label text-xs text-background-100/60">{stat.label}</dt>
                  <dd className="mt-1.5 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                    {stat.value}
                  </dd>
                  <span className="font-label text-[11px] text-accent-400">{stat.hint}</span>
                </div>
              ))}
            </dl>
          </div>

          <div className="anim-fade-in lg:col-span-5">
            <div className="mx-auto max-w-md rounded-lg border border-background-100/15 bg-background-50/5 p-4 backdrop-blur-sm">
              <div className="mb-3 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 font-label text-xs font-medium text-accent-300">
                  <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                  本周主推合集
                </span>
                <span className="rounded-full bg-primary-500 px-2.5 py-1 font-label text-[11px] font-medium text-background-50">
                  {featured.badge}
                </span>
              </div>
              <div className="relative h-44 w-full overflow-hidden rounded-md">
                <img
                  src={featured.cover}
                  alt={`${featured.title} 封面`}
                  title={`${featured.title} 黑料bu合集`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-background-50">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-100/70">
                {featured.summary}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-100/15 pt-3">
                <span className="font-label text-xs text-background-100/60">
                  共 {featured.entries} 份材料 · {featured.updated}
                </span>
                <a
                  href="#collections"
                  className="inline-flex items-center gap-1 whitespace-nowrap font-label text-xs font-medium text-accent-300 hover:text-accent-200"
                >
                  查看合集
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}